import CampOperatorIndex from './CampOperatorIndex';
import CampOperatorCreate from './CampOperatorCreate';
import CampOperatorSettings from './CampOperatorSettings';
import CampOperatorSingle from './CampOperatorSingle';

export default function (app) {

    const settings = CampOperatorSettings;

    app.addModel({
        name: settings.key,
        path: settings.path,
        modelName: settings.modelName,
        endpoint: settings.endpoint,
        idKey: settings.idKey,
        primaryKey: settings.primaryKey,
    });

    // app.addMenu({
    //     key: settings.key,
    //     zone: settings.zone,
    //     label: settings.title,
    //     priority: 14,
    //     items: [
    //         {
    //             label: "All",
    //             path: settings.path,
    //             caps: settings.indexCaps
    //         },
    //         {
    //             label: "Add New",
    //             path: settings.path + "/create",
    //             caps: settings.createCaps
    //         }
    //     ],
    // });

    CampOperatorIndex(app, settings);

    CampOperatorCreate(app, settings);

    CampOperatorSingle(app, settings);

}